import { render, staticRenderFns } from "./confirmRefundDialog.vue?vue&type=template&id=1f50165d&scoped=true&"
import script from "./confirmRefundDialog.vue?vue&type=script&lang=js&"
export * from "./confirmRefundDialog.vue?vue&type=script&lang=js&"
import style0 from "./confirmRefundDialog.vue?vue&type=style&index=0&id=1f50165d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f50165d",
  null
  
)

export default component.exports